import { Inject, Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class SettingsService {
    constructor(
        @Inject('API_URL') private apiUrlOptions: string[],
        private localStorageService: LocalStorageService
    ) {}

    _apiUrl = this.localStorageService.get('apiUrl') || this.apiUrlOptions[0];
    _devMode = this.localStorageService.get('devMode') === 'true';
    _organization = this.localStorageService.get('organizationId') || '';

    get apiUrl() {
        if (environment.local) {
            return this.localStorageService.get('apiUrl') || this.apiUrlOptions[0];
        }
        return this._apiUrl;
    }

    set apiUrl(value: string) {
        this._apiUrl = value;
        this.localStorageService.set('apiUrl', value);
    }

    get devMode() {
        return this._devMode;
    }

    set devMode(value: boolean) {
        this._devMode = value;
        this.localStorageService.set('devMode', String(value));
    }

    get organization() {
        return this._organization;
    }

    set organization(value: string) {
        this.localStorageService.set('organizationId', value);
        this._organization = value;
    }
}
